import type { TPropostaRevisadaData } from '@/features/proposta/interfaces/proposta.type'
import { HttpService } from '@/infra/http'

export class CriarPropostaRevisada extends HttpService {
  execute = async (proposta: TPropostaRevisadaData) => {
    const response = await this.http.post<{
      data: { numero: number }
    }>(`/api/v2/Proposta/salvarRevisao`, proposta)
    return response.data
  }
}
